import { Dropdown } from 'BreetComponents';
import { type DropdownSelectProps, type IDropDownItem } from 'BreetHelpers';
import { type MouseEvent, useCallback, useEffect, useState } from 'react';

const DropdownSelect = ({
	onChange,
	defaultOption = '',
	label = 'Select Item',
	errorMessage,
	id,
	options,
	placeHolder,
	hideSearch,
	CustomItemOption,
}: DropdownSelectProps) => {
	const [selectedItem, setSelectedItem] = useState<IDropDownItem | undefined>(undefined);

	useEffect(() => {
		setSelectedItem(!defaultOption ? undefined : options.find((c) => c.value === defaultOption));
	}, [defaultOption, options]);

	const handleItemSelect = useCallback(
		(item: IDropDownItem) => (e: MouseEvent<HTMLButtonElement>) => {
			e.stopPropagation();
			setSelectedItem(item);
			if (item.id) onChange?.(item.id);
		},
		[onChange]
	);

	return (
		<Dropdown
			handleItemSelect={handleItemSelect}
			selectedItem={selectedItem}
			label={label}
			id={id}
			items={options}
			iconAs='image'
			placeholder={placeHolder ?? 'Search'}
			hideValue
			hideSearch={hideSearch}
			errorMessage={errorMessage}
			CustomItemOption={CustomItemOption}
		/>
	);
};

export default DropdownSelect;
